import React from "react";
import Navbarg from "./Navbar";
import Newsg from "./News";
import Footerg from "./Footer";

function Home(){
   return(
    <>
    <Navbarg/>
    <Newsg/>
    <Footerg/>
    </>
   )
}
export default Home